import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors, border }) => ({
  card: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(3),
    padding: spacing(4),
    overflow: "hidden",
  },
  body: {
    flex: 1,
    minWidth: 0,
    gap: spacing(1),
  },
  brandRow: {
    maxWidth: spacing(18),
  },
  deviceName: {
    color: colors.foregroundDefault,
  },
  connectedRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(1.5),
  },
  connectedDot: {
    width: spacing(2),
    height: spacing(2),
    borderRadius: border.radius.full,
    backgroundColor: colors.backgroundPositive,
  },
  connectedLabel: {
    color: colors.backgroundPositive,
  },
  disconnectButton: {
    width: spacing(13),
    height: spacing(13),
    borderRadius: border.radius.full,
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    backgroundColor: colors.backgroundActive,
  },
  disconnectIcon: {
    width: spacing(5.5),
    height: spacing(5.5),
    color: colors.foregroundDefault,
  },
  disconnectPressed: {
    opacity: 0.7,
    transform: [{ scale: 0.96 }],
  },
}));

export default stylesheet;
